import "regenerator-runtime";
import React from "react";
import "./index.css";
// Registers the Highcharts export menu for every chart (MCS-4316)
import "./helpers/highchartsSetup";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createRoot } from "react-dom/client";
import { configureFetch } from "./helpers";
import { Provider } from "react-redux";
import { store } from "./store";
configureFetch();

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <Provider store={store}>
    <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();